import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './Helpers/polyfill.js';
import './Helpers/logFilters';

Storage.prototype.clear = new Proxy(Storage.prototype.clear, {
  apply(target, thisArg, argList) {
    if (thisArg === sessionStorage) {
      console.warn('[sessionStorage.clear()] called!', new Error().stack);
    }
    return Reflect.apply(target, thisArg, argList);
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

